import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultMessage: {
		id: 'service-desk-premium-landing-page-buttons.learn-more',
		description: 'This text will be shown on premium landing page button as default',
		defaultMessage: 'Learn more',
	},
});
